export const metaCampaignKeys = [
  { key: 'campaignStructureDocument', label: 'Campaign Structure document' },
  { key: 'remarketingAudienceCreated', label: 'Remarketing Audience created' },
  { key: 'pageLinked', label: 'Page Linked' },
  { key: 'urlUtm', label: 'URL/UTM' },
  { key: 'adsOptimizedForPlacements', label: 'Ads Optimized for Placements' },
  { key: 'adsApprovedSpellingChecked', label: 'Ads Approved/ Spelling checked' },
  { key: 'websiteEventsCheckMarked', label: 'Website Events Check Marked' },
  { key: 'customConversionsCreated', label: 'Custom Conversions Created' },
  { key: 'shapeSetup', label: 'Shape Setup' },
  { key: 'budgetCorrect', label: 'Budget Correct' },
]
export const simplifiCampaignKeys = [
  { key: 'namingConvention', label: 'Naming Convention' },
  { key: 'frequencyCapping', label: 'Frequency Capping' },
  { key: 'obaCompliance', label: 'OBA Compliance - Truste' },
  { key: 'budget', label: 'Budget' },
  { key: 'goalCTR', label: 'Goal - CTR - .150' },
  { key: 'location', label: 'Location' },
  { key: 'audiences', label: 'Audiences' },
  { key: 'siteConversions', label: 'Site Conversions' },
  { key: 'dayparting', label: 'Dayparting' },
  { key: 'domainFiltering', label: 'Domain Filtering' },
  { key: 'adsFlights', label: 'Ads/Flights' },
  { key: 'urlUTM', label: 'URL/UTM' },
]
export const googleDisplayCampaignKeys = [
  { key: 'namingConvention', label: 'Naming Convention' },
  { key: 'location', label: 'Location' },
  { key: 'audience', label: 'Audience' },
  { key: 'keywordRetargetingAudience', label: 'Keyword Retargeting Audience' },
  { key: 'competitorWebsites', label: 'Competitor Websites' },
  { key: 'retargetingAudience', label: 'Retargeting Audience' },
  { key: 'adsReview', label: 'Ads Review' },
  { key: 'pellcheck', label: 'Spell check' },
  { key: 'urlCorrect', label: 'Is URL correct' },
  { key: 'adCopySense', label: 'Does ad copy make sense?' },
  { key: 'shapeSetup', label: 'Shape Setup' },
]
export const googleSearchCampaignKeys = [
  {
    key: 'namingConvention',
    label: 'Naming Convention',
    helperText: ['Included "Branded" for only branded campaigns', 'Non-branded should just be named "Search"'],
  },

  {
    key: 'adsReview',
    label: 'Ads Review',
    helperText: [
      'Spell check',
      'Is URL correct',
      'Does ad copy make sense?',
      'Are headlines and descriptions pinned appropriately?',
    ],
  },

  { key: 'keywords', label: 'Keywords' },
  { key: 'negativeKeywords', label: 'Negative Keywords' },
  {
    key: 'adExtensions',
    label: 'Ad Extensions',
    helperText: [
      'Are all extensions/assets created that we have enough information for?',
      'Should at least have callouts, sitelinks, structured snippets, and call extensions setup for clients with full sites.',
      'Automatically created assets turned off? Go to assets > more > more > turn off all',
    ],
  },

  { key: 'locations', label: 'Locations' },
  {
    key: 'budgetBids',
    label: 'Budget and Bids',
    helperText: ['Check the Budget and make sure bids are not set to $.01'],
  },

  { key: 'analyticsLinked', label: 'Analytics Linked' },
  { key: 'goalsImported', label: 'Goals Imported' },
  { key: 'shapeSetup', label: 'Shape Setup' },

  {
    key: 'accountSettings',
    label: 'Account Settings',
    helperText: ['Is auto-tagging turned on?', 'Search Partners turned off'],
  },
]
export const seoTier2Keys = [
  {
    key: 'correctGTMGA4',
    label: 'Confirm Correct GTM & GA4 on client website',
  },
  {
    key: 'confirmGoalsConversions',
    label: 'Confirm Goals & Conversions in GA4',
  },
  {
    key: 'webmasterVerify',
    label: 'Google/Bing Webmasters Verification/Submission',
  },
  {
    key: 'robotsTxt',
    label: 'Set up Robots.txt File',
  },
  {
    key: 'sitemapSubmission',
    label: 'Sitemap Submission and Addition to Robots.txt',
  },
  {
    key: 'googleWebmastersLink',
    label: 'Link Google Webmasters and GA4 to SEranking',
  },
  {
    key: 'vendastaBusListingDist',
    label: 'Vendasta - Business Listing Distribution',
  },
  {
    key: 'vendastaBusListingSync',
    label: 'Vendasta - Business Listing Sync Pro',
  },
  {
    key: 'requestAccessGMB',
    label:
      "Request access to client's GMB. If client has no access, start creation/claim Google listing. (this task is completed in onboarding once request/creation/claim has been initiated)",
  },
  {
    key: 'clientInfoSE',
    label: 'Enter Client into SE Ranking',
  },
  {
    key: 'seoAudit',
    label: 'Perform SEO Audit in SEranking',
  },
  {
    key: 'formFillTest',
    label: 'Perform a Form Fill Test',
  },
  {
    key: 'keywordResearch',
    label: 'Keyword Research',
  },
  {
    key: 'newLaunchCheck',
    label: "If Newly Launched Check 301's",
  },
  {
    key: 'auditKeywordNotes',
    label: 'Provide SEO Audit, Keyword Research and Onboarding Notes for AM in Monday',
  },
]

export const gtmGa4Keys = [
  { key: 'gtm1', label: 'Verify Account Level Access As admin' },
  { key: 'gtm2', label: 'Add Platform Tags' },
  { key: 'gtm3', label: 'Add Event Tags' },
  { key: 'gtm4', label: 'Confirm Tags are firing in preview mode' },
  { key: 'gtm5', label: 'Confirm events are populating in GA4 Debug mode' },
  { key: 'gtm6', label: 'Create Google Ads Account' },
  { key: 'gtm1', label: 'Create Gro Managed GA4' },
  { key: 'gtm2', label: 'Configure domains' },
  { key: 'gtm3', label: "Configure Unwanted Referrals 'Cross-Domain'" },
  { key: 'gtm4', label: 'Enable Google Signals' },
  { key: 'gtm5', label: 'Set Both Data retention options to 14 Months' },
  { key: 'gtm6', label: 'Enable Key Event' },
  { key: 'gtm7', label: "Update Key Event Counting Method to 'once per session'" },
]

export const metaIntegrationKeys = [
  {
    key: 'meta1',
    label: 'Create account',
  },
  {
    key: 'meta2',
    label: 'Assign GRO users',
  },
  {
    key: 'meta3',
    label: 'Configure billing',
  },
  {
    key: 'meta4',
    label: 'Create dataset in GRO Overflow business manager',
  },
  {
    key: 'meta5',
    label: 'Share dataset to main business manager',
  },
  {
    key: 'meta6',
    label: 'Link dataset to ad account',
  },
  {
    key: 'meta7',
    label: 'Create appropriate Tags and Triggers within GTM',
  },
  {
    key: 'meta8',
    label: 'Test custom events',
  },
  {
    key: 'meta9',
    label: 'Verify events in GRO Overflow > Data Sources',
  },
]
export const tiktokIntegrationKeys = [
  {
    key: 'tiktok1',
    label: 'Create ad account',
  },
  {
    key: 'tiktok2',
    label: 'Assign GRO users',
  },
  {
    key: 'tiktok3',
    label: 'Configure billing',
  },
  {
    key: 'tiktok4',
    label: 'Create pixel',
  },
  {
    key: 'tiktok5',
    label: 'Create appropriate Tags and Triggers within GTM',
  },
  {
    key: 'tiktok6',
    label: 'Test events in TikTok Ads UI',
  },
]
export const simplifiIntegrationKeys = [
  {
    key: 'simplifi1',
    label: 'Create ad account',
  },
  {
    key: 'simplifi2',
    label: 'Create Retargeting tags',
  },
  {
    key: 'simplifi3',
    label: 'Create appropriate Tags and Triggers within GTM',
  },
  {
    key: 'simplifi4',
    label: 'Create audiences',
  },
  {
    key: 'simplifi5',
    label: 'Link audiences to tags',
  },
]
export const bingIntegrationKeys = [
  {
    key: 'bing1',
    label: 'Create Bing Ads Account',
  },
  {
    key: 'bing2',
    label: 'Configure payment for account',
  },
  {
    key: 'bing3',
    label: 'Create Bing Universal Event Tag (UET)',
  },
  {
    key: 'bing4',
    label: 'Create the conversion events in platform',
  },
  {
    key: 'bing5',
    label: 'Create appropriate Tags and Triggers within GTM',
  },
  {
    key: 'bing6',
    label: 'Test that UET and conversion tags are firing',
  },
]

export const linkedinIntegrationKeys = [
  {
    key: 'linkedin1',
    label: 'Create LinkedIn Ads Account',
  },
  {
    key: 'linkedin2',
    label: 'Create LinkedIn Pixel',
  },
  {
    key: 'linkedin3',
    label: 'Confirm Advertiser page permissions',
  },
  {
    key: 'linkedin4',
    label: 'Create appropriate Tags and Triggers within GTM',
  },
]
export const snapchatIntegrationKeys = [
  {
    key: 'snapchat=1',
    label: 'Create Snapchat Ads Account',
  },
  {
    key: 'snapchat=2',
    label: 'Create Snap Pixel',
  },
  {
    key: 'snapchat=3',
    label: 'Create appropriate Tags and Triggers within GTM',
  },
]
